module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMTRIMTVWMTVIMFYxNFpNMTEuODUzNSA4Ljg1MzUzTDExLjE0NjUgOC4xNDY0N0w4LjI1IDExLjA0MjlWMEg3LjI1VjExLjA0MjlMNC4zNTM1MyA4LjE0NjQ3TDMuNjQ2NDcgOC44NTM1M0w3Ljc1IDEyLjk1NzFMMTEuODUzNSA4Ljg1MzUzWiIgZmlsbD0iIzA4NTVDNCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-mis-seguros/icon-flag-down.svg
// module id = ddJJ
// module chunks = 1